module.exports = __webpack_public_path__ + "static/img/2.17232571.jpg";